<template>
  <div>
    <template v-if="user && user.portal == 'RHEUMAFIT'">
      <ask-physio />
      <question-modal />
    </template>

    <div class="container" v-if="user">
      <!--<div class="row">
        <div class="col pt-5">
          <h3>
            {{ $t('welcome') }}, {{ user.firstName }} {{ user.lastName }}!
          </h3>
          <p>{{ $t('PAGE_home_welcome_marketing') }}</p>
        </div>
      </div>-->

      <template v-if="user && user.portal == 'GLAD'">
        <b-row class="my-5">
          <b-col>
            <h4>
              {{ $t('PAGE_home_glad_title') }} {{ user.firstName }}
              {{ user.lastName }}
            </h4>
            <vue-markdown
              v-if="$te('PAGE_home_glad_into', 'de')"
              :source="$t('PAGE_home_glad_into')"
              class="markdown"
            />
          </b-col>
        </b-row>
      </template>
      <template v-if="user && user.portal == 'RHEUMAFIT'">
        <feature name="livestream">
          <b-row class="my-5">
            <b-col cols="12" md="5">
              <img src="../assets/rheumafit livestream.svg" />
            </b-col>
            <b-col class="d-flex align-items-center">
              <div>
                <b-row class="mt-2">
                  <b-col>
                    <h5>{{ $t('PAGE_HOME_livestream_title') }}</h5>
                  </b-col>
                </b-row>
                <b-row class="mt-2">
                  <b-col>
                    <p>{{ $t('PAGE_HOME_livestream_description') }}</p>
                  </b-col>
                </b-row>
                <b-row class="mt-2">
                  <b-col>
                    <b-button
                      :to="{ name: 'live' }"
                      variant="outline-primary"
                      >{{ $t('PAGE_HOME_livestream_button') }}</b-button
                    >
                  </b-col>
                </b-row>
              </div>
            </b-col>
          </b-row>
        </feature>

        <feature name="physio">
          <ProgrammsList />
        </feature>
      </template>

      <template v-if="user && user.portal == 'RHEUMAFIT'">
        <div class="row">
          <div class="col py-4">
            <div class="bg-light p-3">
              <div class="row flex align-items-center">
                <div class="col-10">
                  <h5
                    @click="
                      (filter.portal || user.portal) !== 'GLAD' &&
                        $store.commit('setIsFilterOpen', !isFilterOpen)
                    "
                    variant="primary"
                    :class="
                      `m-0 p-0 ${
                        (filter.portal || user.portal) === 'GLAD'
                          ? ''
                          : 'clickable'
                      }`
                    "
                  >
                    <template
                      v-if="(filter.portal || user.portal) === 'RHEUMAFIT'"
                    >
                      <span class="mr-2 ml-1">
                        <i
                          :class="
                            `chevron fa fa-chevron-up ${
                              isFilterOpen &&
                              (filter.portal || user.portal) !== 'GLAD'
                                ? 'isOpen'
                                : ''
                            } ${
                              (filter.portal || user.portal) === 'GLAD'
                                ? 'isDisabled'
                                : ''
                            }`
                          "
                          aria-hidden="true"
                        />
                      </span>
                      {{ $t('PAGE_home_filter_title_short') }}
                    </template>
                  </h5>
                </div>
                <div class="col-2 d-flex justify-content-end">
                  <template
                    v-if="(filter.portal || user.portal) === 'RHEUMAFIT'"
                  >
                    <b-button
                      :variant="filter.favorites ? 'green' : 'light'"
                      :disabled="(filter.portal || user.portal) === 'GLAD'"
                      v-b-popover.hover.top="$t('PAGE_home_filter_favs')"
                      @click="
                        $store.dispatch('setFilter', {
                          favorites: (filter.favorites = !filter.favorites),
                        })
                      "
                      class="ml-2 mr-3 m-0"
                    >
                      <i class="fa fa-heart" aria-hidden="true" />
                    </b-button>
                    <b-button
                      :variant="filter.basfi ? 'dark' : 'light'"
                      v-b-popover.hover.top="$t('PAGE_home_filter_basfi')"
                      :disabled="(filter.portal || user.portal) === 'GLAD'"
                      @click="
                        $store.dispatch('setFilter', {
                          basfi: (filter.basfi = !filter.basfi),
                        })
                      "
                      class="ml-2 mr-3 m-0"
                    >
                      <i class="fa fa-filter" aria-hidden="true" />
                    </b-button>
                  </template>

                  <feature name="glad-toggle" tag="span">
                    <b-button
                      :variant="
                        (filter.portal || user.portal) === 'GLAD'
                          ? 'outline-glad'
                          : 'light'
                      "
                      v-b-popover.hover.top="$t('PAGE_home_filter_glad')"
                      @click="$store.dispatch('setFilter', { portal: 'GLAD' })"
                      style="margin-right: 2px;"
                    >
                      <img src="../assets/glad.png" style="width: 20px;" />
                    </b-button>
                  </feature>
                  <feature name="glad-toggle" tag="span">
                    <b-button
                      :variant="
                        (filter.portal || user.portal) === 'RHEUMAFIT'
                          ? 'outline-primary'
                          : 'light'
                      "
                      v-b-popover.hover.top="$t('PAGE_home_filter_rheumafit')"
                      @click="
                        $store.dispatch('setFilter', { portal: 'RHEUMAFIT' })
                      "
                    >
                      <img src="../assets/bechterew.png" style="width: 20px" />
                    </b-button>
                  </feature>
                </div>
              </div>

              <b-collapse
                :visible="
                  Boolean(isFilterOpen) &&
                    (filter.portal || user.portal) !== 'GLAD'
                "
                id="collapseFilter"
                class="mt-2"
              >
                <playlist-filter />
              </b-collapse>
            </div>
          </div>
        </div>
      </template>
    </div>
    <div v-else>
      <image-head />
    </div>

    <div class="container">
      <template v-if="playlistRows[0]">
        <div v-for="(row, key) in playlistRows" :key="key" class="row">
          <div
            :class="{
              'mb-4': true,
              'col-xl': row.length === 3,
              'col-xl-8': row.length === 2,
              'col-xl-4': row.length === 1,
              'col-lg': row.length === 2,
              'col-lg-6': row.length === 1,
              'col-md': row.length === 2,
              'col-md-6': row.length === 1,
            }"
          >
            <b-card-group deck>
              <playlist-card
                @open="() => play(playlist)"
                v-for="playlist in row"
                v-bind:key="playlist.id"
                :playlist="playlist"
                :loading="adhocPlaylistLoading === playlist.id"
              />
            </b-card-group>
          </div>
        </div>
        <template
          v-if="
            adhocPlaylist && adhocPlaylist.videos && adhocPlaylist.videos.length
          "
        >
          <Playlist
            ref="playlist"
            :visible="true"
            :autoplay="true"
            :videos="adhocPlaylist.videos"
            @close="endTraining"
            @finished="endTraining"
            @event="addEvent"
          />
          <FinishPlaylist
            :visible="adhocPlaylistFinished"
            @close="
              adhocPlaylist = null;
              adhocPlaylistFinished = false;
            "
            @redo="redo"
            @hide="adhocPlaylistFinished = false"
          />
        </template>
      </template>
      <div v-else>
        <b-alert variant="danger" show>{{
          $t('PAGE_home_empty_playlists')
        }}</b-alert>
      </div>

      <template v-if="user && user.portal == 'GLAD'">
        <b-row class="mb-4">
          <b-col>
            <i18n path="PAGE_home_glad_profile_ref" tag="span">
              <b-link
                :to="{ name: 'profile_index', params: { tabIndex: 1 } }"
                >{{ $t('PAGE_home_glad_profile_link') }}</b-link
              >
            </i18n>
          </b-col>
        </b-row>
      </template>
    </div>

    <div v-if="!user" class="container mt-5 py-4">
      <div class="row">
        <div class="col">
          <div class="bg-light" style="padding: 1.4rem !important">
            <p>{{ $t('PAGE_home_login_marketing') }}</p>

            <b-button
              variant="primary"
              @click="$store.dispatch('openLoginModal')"
              >{{ $t('login') }}</b-button
            >
          </div>
        </div>
      </div>
    </div>

    <testimonials
      v-if="user && user.portal == 'RHEUMAFIT'"
      class="container mt-5 py-4"
    />
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex';
import { find } from 'lodash/fp';
import chunk from 'lodash/chunk';

import ImageHead from '@/components/ImageHead';
import QuestionModal from '@/components/modals/Question';
import AskPhysio from '@/components/AskPhysio';
import PlaylistCard from '@/components/PlaylistCard';
import TestimonialCard from '@/components/TestimonialCard';
import Testimonials from '@/components/Testimonials';
import PlaylistFilter from '@/components/PlaylistFilter';
import Loader from '@/components/Loader';
import ProgrammsList from '@/components/ProgrammsList';
import Playlist from '@/components/Playlist';
import FinishPlaylist from '@/components/modals/FinishPlaylist';
import VueMarkdown from 'vue-markdown';

import feature from '@/feature';

export default {
  name: 'home',
  data() {
    return {
      collapseIsOpen: false,
      adhocPlaylist: null,
      adhocPlaylistLoading: null,
      adhocPlaylistFinished: false,
      events: [],
    };
  },
  components: {
    Testimonials,
    PlaylistCard,
    AskPhysio,
    QuestionModal,
    ImageHead,
    PlaylistFilter,
    Loader,
    ProgrammsList,
    Playlist,
    FinishPlaylist,
    VueMarkdown,
  },
  asyncData({ store, route }) {
    store.dispatch('getPlaylists');
    if (route.query.modal === 'login') {
      store.dispatch('openLoginModal');
    }
  },
  methods: {
    addEvent(event) {
      if (this.adhocPlaylist) {
        this.events.push(event);
      }
    },
    endTraining() {
      this.adhocPlaylistFinished = true;
      this.events.push({
        timestamp: new Date(),
        event: 'requestEnd',
      });

      if (this.isLoggedIn)
        this.$store
          .dispatch('finishPlaylist', {
            params: { id: this.adhocPlaylist.id },
            data: { events: this.events },
          })
          .then(() => {
            this.events = [];
          });

      this.showPlaylist = false;
    },
    redo() {
      this.$refs.playlist.$children[0].restart();
      this.adhocPlaylistFinished = false;
    },
    play(playlist) {
      this.adhocPlaylistLoading = playlist.id;
      this.$store
        .dispatch('getPlaylist', playlist.id)
        .then(() => {
          this.adhocPlaylist =
            find({ id: playlist.id }, this.playlists) || null;
        })
        .finally(() => {
          this.adhocPlaylistLoading = null;
        });
    },
  },
  computed: {
    ...mapState(['filter']),
    ...mapState({
      programmsPending: state => state.api.pending.programms,
      playlistsPending: state =>
        state.api.pending.playlists && !state.api.playlists.length,
      playlistsError: state => state.api.error.playlists,
    }),
    ...mapGetters([
      'programms',
      'user',
      'filteredPlaylists',
      'hasFilter',
      'isFilterOpen',
      'isMobile',
      'playlists',
      'isLoggedIn',
    ]),
    resourcesOptions() {
      return [
        { label: this.$t('PAGE_home_filter_q3_matt'), value: 'matt' },
        //{ label: this.$t("PAGE_home_filter_q3_band"), value: "band" },
        { label: this.$t('PAGE_home_filter_q3_towel'), value: 'towel' },
        { label: this.$t('PAGE_home_filter_q3_stool'), value: 'stool' },
        { label: this.$t('PAGE_home_filter_q3_ball'), value: 'ball' },
      ];
    },
    playlistRows() {
      const fp = this.playlistsPending
        ? this.filteredPlaylists.playlists.concat([
            { id: 'pending-1', isEmpty: true },
            { id: 'pending-2', isEmpty: true },
            { id: 'pending-3', isEmpty: true },
            { id: 'pending-4', isEmpty: true },
            { id: 'pending-5', isEmpty: true },
          ])
        : this.filteredPlaylists.playlists;

      if (['sm'].includes(this.$mq)) return chunk(fp, 1);

      if (['md', 'lg'].includes(this.$mq)) return chunk(fp, 2);

      return chunk(fp, 3);
    },
  },
};
</script>

<style lang="scss" scoped>
@import 'node_modules/bootstrap/scss/functions';
@import '/../theme';
.chevron {
  transition: transform 0.4s;
  color: theme-color('green');
}
.isDisabled {
  color: theme-color('grey');
}
.isOpen {
  transform: rotateZ(-180deg);
}
</style>



// WEBPACK FOOTER //
// src/pages/Home.vue